import * as React from 'react'
import { useNavigate } from 'react-router-dom'
import LoginLayout from '../Login/components/LoginLayout'
import { Container, Box, Button, Typography } from '@mui/material'
import DescriptionTitle from './components/DescriptionTitle/DescriptionTitle'

const CrmConnect = () => {
	const navigate = useNavigate()

	const handleSubmit = (e: React.FormEvent) => {
		e.preventDefault()

		const queryParams = new URLSearchParams(window.location.search)
		const paramValue = queryParams.get('code')
		const marketplace = queryParams.get('marketplace') || 'true'
		navigate(`/login${`?marketplace=${marketplace}${paramValue ? `&code=${paramValue}` : ''}`}`)
	}

	return (
		<LoginLayout>
			<Container component="main" maxWidth="xs">
				<Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
					<Typography variant="h1" sx={{ padding: 2 }}></Typography>
					<DescriptionTitle>Connect your CRM to Prop!</DescriptionTitle>
					<Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2 }}>
						Submit
					</Button>
				</Box>
			</Container>
		</LoginLayout>
	)
}

export default CrmConnect
